var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_41274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5791 20.43L23.4688 13.3443C22.6022 12.6743 21.3934 12.6743 20.534 13.3443L11.4238 20.43C10.9505 20.8014 10.8631 21.486 11.2345 21.9666C11.4529 22.2433 11.7734 22.389 12.1011 22.389C12.3341 22.389 12.5744 22.3161 12.7711 22.1559L13.725 21.4131V29.2053C13.725 30.283 14.5989 31.1569 15.6767 31.1569H28.3407C29.4185 31.1569 30.2924 30.283 30.2924 29.2053V21.4131L31.2464 22.1559C31.7197 22.52 32.4116 22.4399 32.7757 21.9666C33.1471 21.4932 33.0597 20.8014 32.5864 20.43H32.5791ZM28.1004 28.9722H15.9025V19.7163L21.7939 15.1357L21.874 15.092C21.9468 15.0338 22.0561 15.0338 22.1289 15.092L22.2017 15.1357L28.0931 19.7163V28.9722H28.1004Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_41274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18.3151,
    fill: "white",
    transform: "translate(11 12.8418)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteManagement);
export default __webpack_public_path__ + "static/media/Site_management.586f7ab576f40ad864f3cbf10c4b62fa.svg";
export { ForwardRef as ReactComponent };